<template>
  <div class="flex items-center w-full mt-6 gap-2">
    <l-button
      class="flex-1"
      size="small"
      type="secondary"
      color="custom"
      :disabled="disableBack"
      @click="handleBack"
    >
      {{ backLabel || $t('steps.back') }}
    </l-button>
    <l-button
      v-if="showContinue"
      class="flex-1"
      size="small"
      color="custom"
      :loading="loading"
      :disabled="disableContinue || loading"
      @click="handleContinue"
    >
      {{ continueLabel || $t('steps.continue') }}
    </l-button>
  </div>
</template>

<script setup lang="ts">
import { LButton } from '@last/core-ui/paprika'

type Props = {
  backLabel?: string
  continueLabel?: string
  loading?: boolean
  disableBack?: boolean
  disableContinue?: boolean
  showContinue?: boolean
}

withDefaults(defineProps<Props>(), {
  backLabel: '',
  continueLabel: '',
  loading: false,
  disableBack: false,
  disableContinue: false,
  showContinue: true
})

const emit = defineEmits(['back', 'continue'])

function handleBack() {
  emit('back')
}

function handleContinue() {
  emit('continue')
}
</script>
